import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { Shape2, Shape2Icon, Shape2Tone } from '../Shape2/Shape2';

import './TickOverlay.css';

export interface TickOverlayProps {
    isVisible?: boolean;
}

export const TickOverlay = ({ isVisible }: TickOverlayProps) => (
    <div
        className={Bem.cls('tick-overlay', '', {
            visible: Boolean(isVisible)
        })}
    >
        <Shape2
            width={22}
            height={22}
            tone={Shape2Tone.white}
            icon={Shape2Icon.tick}
        />
    </div>
);
